import { render, staticRenderFns } from "./AddLockTab.vue?vue&type=template&id=3abf2e4d&scoped=true&"
import script from "./AddLockTab.vue?vue&type=script&lang=js&"
export * from "./AddLockTab.vue?vue&type=script&lang=js&"
import style0 from "./AddLockTab.vue?vue&type=style&index=0&id=3abf2e4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abf2e4d",
  null
  
)

export default component.exports